// ─── 文本工具函数 ────────────────────────────────────────────────────────────────

// ─── CSV / TSV / SQL / Markdown / JSON / HTML 表格互转 ────────────────────────

function parseCsv(text, sep = ',') {
  const rows = [];
  const lines = text.trim().split('\n');
  for (const line of lines) {
    // 简单解析，处理带引号字段
    const cols = [];
    let cur = '', inQ = false;
    for (let i = 0; i < line.length; i++) {
      const c = line[i];
      if (c === '"') { inQ = !inQ; continue; }
      if (c === sep && !inQ) { cols.push(cur.trim()); cur = ''; continue; }
      cur += c;
    }
    cols.push(cur.trim());
    rows.push(cols);
  }
  return rows;
}

function rowsToSql(rows, table = 'table_name') {
  if (rows.length < 2) return '';
  const headers = rows[0];
  const cols = headers.map(h => `\`${h}\``).join(', ');
  const insertRows = rows.slice(1).map(r => {
    const vals = r.map(v => `'${String(v).replace(/'/g, "''")}'`).join(', ');
    return `INSERT INTO \`${table}\` (${cols}) VALUES (${vals});`;
  });
  const creates = headers.map(h => `  \`${h}\` TEXT`).join(',\n');
  return `CREATE TABLE \`${table}\` (\n  \`id\` INT AUTO_INCREMENT PRIMARY KEY,\n${creates}\n);\n\n${insertRows.join('\n')}`;
}

function rowsToMarkdown(rows) {
  if (rows.length < 1) return '';
  const widths = rows[0].map((_, i) => Math.max(...rows.map(r => String(r[i] ?? '').length), 3));
  const pad = (s, w) => String(s).padEnd(w);
  const header = '| ' + rows[0].map((h, i) => pad(h, widths[i])).join(' | ') + ' |';
  const sep = '| ' + widths.map(w => '-'.repeat(w)).join(' | ') + ' |';
  const body = rows.slice(1).map(r => '| ' + r.map((v, i) => pad(v ?? '', widths[i])).join(' | ') + ' |');
  return [header, sep, ...body].join('\n');
}

function rowsToHtml(rows) {
  if (rows.length < 1) return '';
  const th = rows[0].map(h => `  <th>${h}</th>`).join('\n');
  const trs = rows.slice(1).map(r => {
    const tds = r.map(v => `    <td>${v ?? ''}</td>`).join('\n');
    return `  <tr>\n${tds}\n  </tr>`;
  });
  return `<table>\n<thead>\n<tr>\n${th}\n</tr>\n</thead>\n<tbody>\n${trs.join('\n')}\n</tbody>\n</table>`;
}

function rowsToJson(rows) {
  if (rows.length < 2) return '[]';
  const headers = rows[0];
  const data = rows.slice(1).map(r => {
    const obj = {};
    headers.forEach((h, i) => { obj[h] = r[i] ?? ''; });
    return obj;
  });
  return JSON.stringify(data, null, 2);
}

function rowsToCsv(rows, sep = ',') {
  return rows.map(r => r.map(v => {
    const s = String(v ?? '');
    return s.includes(sep) || s.includes('"') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
  }).join(sep)).join('\n');
}

// parse markdown table
function parseMarkdown(text) {
  const lines = text.trim().split('\n').filter(l => l.includes('|'));
  const rows = lines
    .filter(l => !/^\|[\s\-:|]+\|$/.test(l.trim()))
    .map(l => l.replace(/^\||\|$/g, '').split('|').map(c => c.trim()));
  return rows;
}

// parse HTML table
function parseHtmlTable(html) {
  const rows = [];
  const trRe = /<tr[^>]*>([\s\S]*?)<\/tr>/gi;
  // const cellRe = /<t[hd][^>]*>([\s\S]*?)<\/t[hd]>/gi;
  let trM;
  while ((trM = trRe.exec(html)) !== null) {
    const cells = [];
    let cm;
    const cellRe2 = /<t[hd][^>]*>([\s\S]*?)<\/t[hd]>/gi;
    while ((cm = cellRe2.exec(trM[1])) !== null) {
      cells.push(cm[1].replace(/<[^>]+>/g, '').trim());
    }
    if (cells.length > 0) rows.push(cells);
  }
  return rows;
}

// parse JSON array of objects
function parseJsonTable(text) {
  const data = JSON.parse(text);
  if (!Array.isArray(data) || data.length === 0) return [];
  const headers = Object.keys(data[0]);
  const rows = [headers, ...data.map(r => headers.map(h => String(r[h] ?? '')))];
  return rows;
}

// parse SQL SELECT results or INSERT data (basic)
function parseSqlInserts(text) {
  // Try to extract column names from INSERT statements
  const insertRe = /INSERT INTO\s+[`"']?\w+[`"']?\s*\(([^)]+)\)\s*VALUES\s*\(([^)]+)\)/gi;
  let m;
  const rows = [];
  let headers = null;
  while ((m = insertRe.exec(text)) !== null) {
    if (!headers) {
      headers = m[1].split(',').map(s => s.trim().replace(/[`"']/g, ''));
      rows.push(headers);
    }
    const vals = m[2].split(',').map(s => s.trim().replace(/^'|'$/g, '').replace(/''/g, "'"));
    rows.push(vals);
  }
  return rows;
}

export const csvToSql = (input) => rowsToSql(parseCsv(input));
export const tsvToSql = (input) => rowsToSql(parseCsv(input, '\t'));
export const sqlToMarkdown = (input) => rowsToMarkdown(parseSqlInserts(input));
export const csvToMarkdown = (input) => rowsToMarkdown(parseCsv(input));
export const sqlToJson = (input) => rowsToJson(parseSqlInserts(input));
export const sqlToHtml = (input) => rowsToHtml(parseSqlInserts(input));
export const htmlToMarkdown = (input) => rowsToMarkdown(parseHtmlTable(input));
export const htmlToCsv = (input) => rowsToCsv(parseHtmlTable(input));
export const jsonTableToCsv = (input) => rowsToCsv(parseJsonTable(input));
export const tsvToCsv = (input) => rowsToCsv(parseCsv(input, '\t'));
export const markdownToHtml = (input) => rowsToHtml(parseMarkdown(input));
export const csvToHtml = (input) => rowsToHtml(parseCsv(input));
export const csvToJson = (input) => rowsToJson(parseCsv(input));
export const tsvToJson = (input) => rowsToJson(parseCsv(input, '\t'));
export const markdownToCsv = (input) => rowsToCsv(parseMarkdown(input));
export const markdownToJson = (input) => rowsToJson(parseMarkdown(input));
export const htmlToJson = (input) => rowsToJson(parseHtmlTable(input));
export const htmlToSql = (input) => rowsToSql(parseHtmlTable(input));
export const sqlToCsv = (input) => rowsToCsv(parseSqlInserts(input));
export const jsonTableToHtml = (input) => rowsToHtml(parseJsonTable(input));
export const htmlToTsv = (input) => rowsToCsv(parseHtmlTable(input), '\t');
export const markdownToTsv = (input) => rowsToCsv(parseMarkdown(input), '\t');
export const tsvToHtml = (input) => rowsToHtml(parseCsv(input, '\t'));
export const csvToTsv = (input) => rowsToCsv(parseCsv(input), '\t');
export const jsonTableToSql = (input) => rowsToSql(parseJsonTable(input));
export const jsonTableToMarkdown = (input) => rowsToMarkdown(parseJsonTable(input));
export const markdownToSql = (input) => rowsToSql(parseMarkdown(input));
export const tsvToMarkdown = (input) => rowsToMarkdown(parseCsv(input, '\t'));
export const sqlToTsv = (input) => rowsToCsv(parseSqlInserts(input), '\t');
export const jsonTableToTsv = (input) => rowsToCsv(parseJsonTable(input), '\t');

// ─── Figlet (ASCII art text) ─────────────────────────────────────────────────

// const FIGLET_CHARS = {
//   A: [' /\\ ', '/  \\', '----', '/  \\', '/    \\'],
// };

export function figlet(text) {
  // Very simplified block letter generator using # characters
  const letters = {
    'A': ['  #  ', ' # # ', '#####', '#   #', '#   #'],
    'B': ['#### ', '#   #', '#### ', '#   #', '#### '],
    'C': [' ####', '#    ', '#    ', '#    ', ' ####'],
    'D': ['#### ', '#   #', '#   #', '#   #', '#### '],
    'E': ['#####', '#    ', '#### ', '#    ', '#####'],
    'F': ['#####', '#    ', '#### ', '#    ', '#    '],
    'G': [' ####', '#    ', '#  ##', '#   #', ' ####'],
    'H': ['#   #', '#   #', '#####', '#   #', '#   #'],
    'I': ['#####', '  #  ', '  #  ', '  #  ', '#####'],
    'J': ['#####', '    #', '    #', '#   #', ' ### '],
    'K': ['#   #', '#  # ', '###  ', '#  # ', '#   #'],
    'L': ['#    ', '#    ', '#    ', '#    ', '#####'],
    'M': ['#   #', '## ##', '# # #', '#   #', '#   #'],
    'N': ['#   #', '##  #', '# # #', '#  ##', '#   #'],
    'O': [' ### ', '#   #', '#   #', '#   #', ' ### '],
    'P': ['#### ', '#   #', '#### ', '#    ', '#    '],
    'Q': [' ### ', '#   #', '# # #', '#  ##', ' ####'],
    'R': ['#### ', '#   #', '#### ', '#  # ', '#   #'],
    'S': [' ####', '#    ', ' ### ', '    #', '#### '],
    'T': ['#####', '  #  ', '  #  ', '  #  ', '  #  '],
    'U': ['#   #', '#   #', '#   #', '#   #', ' ### '],
    'V': ['#   #', '#   #', '#   #', ' # # ', '  #  '],
    'W': ['#   #', '#   #', '# # #', '## ##', '#   #'],
    'X': ['#   #', ' # # ', '  #  ', ' # # ', '#   #'],
    'Y': ['#   #', ' # # ', '  #  ', '  #  ', '  #  '],
    'Z': ['#####', '   # ', '  #  ', ' #   ', '#####'],
    '0': [' ### ', '#  ##', '# # #', '##  #', ' ### '],
    '1': ['  #  ', ' ##  ', '  #  ', '  #  ', '#####'],
    '2': [' ### ', '#   #', '  ## ', ' #   ', '#####'],
    '3': ['#### ', '    #', '  ## ', '    #', '#### '],
    '4': ['#   #', '#   #', '#####', '    #', '    #'],
    '5': ['#####', '#    ', '#### ', '    #', '#### '],
    '6': [' ### ', '#    ', '#### ', '#   #', ' ### '],
    '7': ['#####', '   # ', '  #  ', ' #   ', '#    '],
    '8': [' ### ', '#   #', ' ### ', '#   #', ' ### '],
    '9': [' ### ', '#   #', ' ####', '    #', ' ### '],
    ' ': ['     ', '     ', '     ', '     ', '     '],
    '!': ['  #  ', '  #  ', '  #  ', '     ', '  #  '],
    '.': ['     ', '     ', '     ', '     ', '  #  '],
    '-': ['     ', '     ', '#####', '     ', '     '],
  };
  const chars = text.toUpperCase().split('');
  const rows = [[], [], [], [], []];
  for (const c of chars) {
    const g = letters[c] || letters[' '];
    for (let i = 0; i < 5; i++) rows[i].push(g[i]);
  }
  return rows.map(r => r.join(' ')).join('\n');
}

// ─── 文本排序 ─────────────────────────────────────────────────────────────────

export function sortText(text, options = {}) {
  const { order = 'asc', byLength = false, unique = false, numeric = false } = options;
  let lines = text.split('\n');
  if (unique) lines = [...new Set(lines)];
  lines.sort((a, b) => {
    if (byLength) return a.length - b.length;
    if (numeric) return parseFloat(a) - parseFloat(b);
    return a.localeCompare(b, 'zh-CN');
  });
  if (order === 'desc') lines.reverse();
  return lines.join('\n');
}

// ─── Lorem Ipsum ─────────────────────────────────────────────────────────────

export function loremIpsum(paragraphs = 3) {
  const sentences = [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
    'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.',
    'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt.',
    'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.',
    'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet.',
    'Ut labore et dolore magnam aliquam quaerat voluptatem.',
  ];
  const result = [];
  for (let i = 0; i < paragraphs; i++) {
    const count = 3 + Math.floor(Math.random() * 4);
    const para = Array.from({ length: count }, (_, j) => sentences[(i * count + j) % sentences.length]);
    result.push(para.join(' '));
  }
  return result.join('\n\n');
}

// ─── ASCII 码表 ───────────────────────────────────────────────────────────────

export function asciiTable(from = 32, to = 127) {
  const rows = ['Dec  Hex  Oct  Char'];
  rows.push('-'.repeat(22));
  for (let i = from; i <= Math.min(to, 127); i++) {
    const char = i < 32 ? ['NUL','SOH','STX','ETX','EOT','ENQ','ACK','BEL','BS','TAB','LF','VT','FF','CR','SO','SI','DLE','DC1','DC2','DC3','DC4','NAK','SYN','ETB','CAN','EM','SUB','ESC','FS','GS','RS','US'][i] : i === 127 ? 'DEL' : String.fromCharCode(i);
    rows.push(`${String(i).padStart(3)}  ${i.toString(16).toUpperCase().padStart(3)}  ${i.toString(8).padStart(3)}  ${char}`);
  }
  return rows.join('\n');
}

// ─── 文本分割 ─────────────────────────────────────────────────────────────────

export function splitText(text, separator, chunkSize) {
  if (separator !== undefined && separator !== '') {
    return text.split(separator).map((s, i) => `[${i + 1}] ${s}`).join('\n');
  }
  if (chunkSize > 0) {
    const chunks = [];
    for (let i = 0; i < text.length; i += chunkSize) {
      chunks.push(text.slice(i, i + chunkSize));
    }
    return chunks.map((s, i) => `[${i + 1}] ${s}`).join('\n');
  }
  return text;
}

// ─── 大小写转换 ───────────────────────────────────────────────────────────────

export function caseConvert(text, mode) {
  switch (mode) {
    case 'upper': return text.toUpperCase();
    case 'lower': return text.toLowerCase();
    case 'title': return text.replace(/\b\w/g, c => c.toUpperCase());
    case 'camel': return text.replace(/[-_\s]+(.)/g, (_, c) => c.toUpperCase()).replace(/^./, c => c.toLowerCase());
    case 'pascal': return text.replace(/[-_\s]+(.)/g, (_, c) => c.toUpperCase()).replace(/^./, c => c.toUpperCase());
    case 'snake': return text.replace(/([A-Z])/g, '_$1').replace(/[-\s]+/g, '_').toLowerCase().replace(/^_/, '');
    case 'kebab': return text.replace(/([A-Z])/g, '-$1').replace(/[_\s]+/g, '-').toLowerCase().replace(/^-/, '');
    case 'constant': return text.replace(/([A-Z])/g, '_$1').replace(/[-\s]+/g, '_').toUpperCase().replace(/^_/, '');
    case 'sentence': return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    case 'toggle': return text.split('').map(c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()).join('');
    case 'alternating': return text.split('').map((c, i) => i % 2 === 0 ? c.toLowerCase() : c.toUpperCase()).join('');
    default: return text;
  }
}

// ─── 字符串转义 / 反转义 ──────────────────────────────────────────────────────

export function escapeString(text, mode = 'js') {
  switch (mode) {
    case 'js':
      return text.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/'/g, "\\'").replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t');
    case 'html':
      return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    case 'regex':
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    case 'sql':
      return text.replace(/'/g, "''").replace(/\\/g, '\\\\');
    case 'csv':
      return text.includes(',') || text.includes('"') || text.includes('\n') ? `"${text.replace(/"/g, '""')}"` : text;
    default: return text;
  }
}

export function unescapeString(text, mode = 'js') {
  switch (mode) {
    case 'js':
      return text.replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t').replace(/\\"/g, '"').replace(/\\'/g, "'").replace(/\\\\/g, '\\');
    case 'html':
      return text.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
    default: return text;
  }
}

// ─── 文本分析 ─────────────────────────────────────────────────────────────────

export function analyzeText(text) {
  const words = text.trim() ? text.trim().split(/\s+/) : [];
  const sentences = text.trim() ? text.split(/[.!?。！？]+/).filter(s => s.trim()) : [];
  const lines = text.split('\n');
  const charFreq = {};
  for (const c of text) charFreq[c] = (charFreq[c] || 0) + 1;
  const topChars = Object.entries(charFreq)
    .filter(([c]) => c.trim())
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10)
    .map(([c, n]) => `'${c}': ${n}次`);
  const wordFreq = {};
  for (const w of words) {
    const wl = w.toLowerCase();
    wordFreq[wl] = (wordFreq[wl] || 0) + 1;
  }
  const topWords = Object.entries(wordFreq).sort((a, b) => b[1] - a[1]).slice(0, 10).map(([w, n]) => `'${w}': ${n}次`);
  return {
    chars: text.length,
    charsNoSpace: text.replace(/\s/g, '').length,
    words: words.length,
    sentences: sentences.length,
    lines: lines.length,
    paragraphs: text.split(/\n\n+/).filter(p => p.trim()).length,
    avgWordLength: words.length ? (words.reduce((s, w) => s + w.length, 0) / words.length).toFixed(1) : 0,
    topChars,
    topWords,
  };
}

// ─── 文本提取 ─────────────────────────────────────────────────────────────────

export function extractText(text, type) {
  switch (type) {
    case 'emails': return (text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g) || []).join('\n');
    case 'urls': return (text.match(/https?:\/\/[^\s]+/g) || []).join('\n');
    case 'ips': return (text.match(/\b(?:\d{1,3}\.){3}\d{1,3}\b/g) || []).join('\n');
    case 'phones': return (text.match(/(?:\+?86)?1[3-9]\d{9}|\+?[0-9\s\-()]{7,20}/g) || []).join('\n');
    case 'numbers': return (text.match(/-?\d+(?:\.\d+)?/g) || []).join('\n');
    case 'dates': return (text.match(/\d{4}[-/]\d{1,2}[-/]\d{1,2}/g) || []).join('\n');
    case 'hashtags': return (text.match(/#[\w\u4e00-\u9fa5]+/g) || []).join('\n');
    case 'mentions': return (text.match(/@\w+/g) || []).join('\n');
    case 'lines_with': return text;
    default: return '';
  }
}

// ─── 密码生成器 ───────────────────────────────────────────────────────────────

export function generatePassword(length = 16, options = {}) {
  const { upper = true, lower = true, numbers = true, symbols = true, count = 1 } = options;
  let chars = '';
  if (upper) chars += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (lower) chars += 'abcdefghijklmnopqrstuvwxyz';
  if (numbers) chars += '0123456789';
  if (symbols) chars += '!@#$%^&*()_+-=[]{}|;:,.<>?';
  if (!chars) chars = 'abcdefghijklmnopqrstuvwxyz';
  const results = [];
  for (let n = 0; n < count; n++) {
    let pw = '';
    for (let i = 0; i < length; i++) {
      pw += chars[Math.floor(Math.random() * chars.length)];
    }
    results.push(pw);
  }
  return results;
}

// ─── 文本去重 ─────────────────────────────────────────────────────────────────

export function deduplicateText(text, options = {}) {
  const { caseSensitive = true, trimLines = true } = options;
  let lines = text.split('\n');
  if (trimLines) lines = lines.map(l => l.trim());
  const seen = new Set();
  const unique = [];
  const dups = [];
  for (const line of lines) {
    const key = caseSensitive ? line : line.toLowerCase();
    if (seen.has(key)) { dups.push(line); }
    else { seen.add(key); unique.push(line); }
  }
  return { unique: unique.join('\n'), duplicates: dups, removedCount: dups.length };
}

// ─── 文本比较 ─────────────────────────────────────────────────────────────────

export function compareText(text1, text2) {
  const lines1 = text1.split('\n');
  const lines2 = text2.split('\n');
  const result = [];
  const maxLen = Math.max(lines1.length, lines2.length);
  let added = 0, removed = 0, changed = 0;
  for (let i = 0; i < maxLen; i++) {
    const l1 = lines1[i];
    const l2 = lines2[i];
    if (l1 === undefined) { result.push(`+ [${i + 1}] ${l2}`); added++; }
    else if (l2 === undefined) { result.push(`- [${i + 1}] ${l1}`); removed++; }
    else if (l1 !== l2) { result.push(`~ [${i + 1}] - ${l1}`); result.push(`~ [${i + 1}] + ${l2}`); changed++; }
    else { result.push(`  [${i + 1}] ${l1}`); }
  }
  const summary = `统计: +${added} 新增, -${removed} 删除, ~${changed} 修改\n${'─'.repeat(40)}\n`;
  return summary + result.join('\n');
}

// ─── Slug 生成 ────────────────────────────────────────────────────────────────

export function generateSlug(text) {
  return text
    .toLowerCase()
    .replace(/[\u4e00-\u9fa5]+/g, (m) => m.split('').map(() => 'zh').join('-'))
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .replace(/-+/g, '-');
}

// ─── 随机字符串 ───────────────────────────────────────────────────────────────

export function randomString(length = 16, charset = 'alphanumeric') {
  const charsets = {
    alphanumeric: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
    alpha: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
    numeric: '0123456789',
    hex: '0123456789abcdef',
    base64: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
    symbol: '!@#$%^&*()_+-=[]{}|;:,.<>?',
  };
  const chars = charsets[charset] || charsets.alphanumeric;
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
}

// ─── 字符串反转义 ─────────────────────────────────────────────────────────────

export function unescapeHtml(text) { return unescapeString(text, 'html'); }
export function unescapeJs(text) { return unescapeString(text, 'js'); }

// ─── 公式计算 ─────────────────────────────────────────────────────────────────

export function evalFormula(expr) {
  // Safe eval using math only
  const sanitized = expr
    .replace(/[^0-9+\-*/().%\s^sincotaqlgepMLPIE]/g, '')
    .replace(/\^/g, '**')
    .replace(/sin/g, 'Math.sin')
    .replace(/cos/g, 'Math.cos')
    .replace(/tan/g, 'Math.tan')
    .replace(/sqrt/g, 'Math.sqrt')
    .replace(/log/g, 'Math.log10')
    .replace(/ln/g, 'Math.log')
    .replace(/PI/g, 'Math.PI')
    .replace(/E/g, 'Math.E');
  try {
    // eslint-disable-next-line no-new-func
    const result = new Function(`return (${sanitized})`)();
    return String(result);
  } catch {
    throw new Error('无效的表达式');
  }
}

// ─── 简繁转换（基础映射） ──────────────────────────────────────────────────────

const S2T_MAP = {'爱':'愛','安':'安','帮':'幫','备':'備','变':'變','标':'標','别':'別','补':'補','才':'才','场':'場','车':'車','处':'處','传':'傳','创':'創','单':'單','当':'當','点':'點','电':'電','东':'東','动':'動','对':'對','发':'發','飞':'飛','丰':'豐','复':'復','干':'幹','个':'個','给':'給','国':'國','过':'過','和':'和','后':'後','话':'話','华':'華','画':'畫','汇':'匯','会':'會','机':'機','级':'級','计':'計','家':'家','见':'見','将':'將','节':'節','进':'進','经':'經','决':'決','来':'來','乐':'樂','类':'類','里':'裡','联':'聯','两':'兩','临':'臨','领':'領','录':'錄','码':'碼','们':'們','面':'面','鸟':'鳥','农':'農','欧':'歐','气':'氣','钱':'錢','亲':'親','区':'區','权':'權','热':'熱','认':'認','软':'軟','时':'時','实':'實','书':'書','树':'樹','丝':'絲','岁':'歲','台':'臺','态':'態','团':'團','网':'網','为':'為','问':'問','无':'無','显':'顯','现':'現','线':'線','响':'響','写':'寫','选':'選','学':'學','样':'樣','业':'業','义':'義','阴':'陰','应':'應','语':'語','员':'員','约':'約','运':'運','战':'戰','张':'張','这':'這','证':'證','纸':'紙','种':'種','众':'眾','转':'轉','状':'狀','装':'裝','总':'總','组':'組'};
const T2S_MAP = Object.fromEntries(Object.entries(S2T_MAP).map(([s, t]) => [t, s]));

export function simplifiedToTraditional(text) {
  return text.split('').map(c => S2T_MAP[c] || c).join('');
}

export function traditionalToSimplified(text) {
  return text.split('').map(c => T2S_MAP[c] || c).join('');
}

// ─── Markdown 预览 ────────────────────────────────────────────────────────────

export function markdownToHtmlPreview(md) {
  return md
    .replace(/^#{6}\s(.+)$/gm, '<h6>$1</h6>')
    .replace(/^#{5}\s(.+)$/gm, '<h5>$1</h5>')
    .replace(/^#{4}\s(.+)$/gm, '<h4>$1</h4>')
    .replace(/^#{3}\s(.+)$/gm, '<h3>$1</h3>')
    .replace(/^#{2}\s(.+)$/gm, '<h2>$1</h2>')
    .replace(/^#{1}\s(.+)$/gm, '<h1>$1</h1>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/^>\s(.+)$/gm, '<blockquote>$1</blockquote>')
    .replace(/^-\s(.+)$/gm, '<li>$1</li>')
    .replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>')
    .replace(/^\d+\.\s(.+)$/gm, '<li>$1</li>')
    .replace(/\n\n/g, '</p><p>')
    .replace(/^(?!<[hupblo])(.+)$/gm, '<p>$1</p>');
}

// ─── 行列转换工具 ─────────────────────────────────────────────────────────────

// 文本行变列：将逗号分隔的一行拆成多行
export function rowToColumn(text) {
  return text.split(',').map(s => s.trim()).join('\n');
}

// 文本列转行：将多行合并为逗号分隔的一行
export function columnToRow(text) {
  return text.split('\n').map(s => s.trim()).filter(s => s).join(',');
}

// 文本列追加逗号：每行末尾加逗号
export function columnAppendComma(text) {
  return text.split('\n').map(s => s.trim()).filter(s => s).map(s => s + ',').join('\n');
}

// 文本列追加引号并转行：每行加引号后合并为逗号分隔的一行
export function columnQuoteToRow(text) {
  return text.split('\n').map(s => s.trim()).filter(s => s).map(s => `"${s}"`).join(',');
}
